var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 47.5,
    r: 47.5,
    fill: "#B0ADCA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3373_50648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.1668 73.1968C56.8377 73.1968 38.6674 73.1968 20.25 73.1968C20.4029 64.9247 23.9558 58.6155 30.7734 54.6372C34.1733 52.6509 38.3968 51.5059 42.3555 51.1613C47.5672 50.7056 52.9966 50.7874 58.1318 51.7338C68.1669 53.5798 76.0668 63.8323 75.1668 73.1968Z",
    fill: "#3C3675"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3218 33.8519C61.2866 41.3178 55.3808 47.2122 47.9044 47.2239C40.2633 47.2414 34.3223 41.3119 34.3517 33.6883C34.3752 26.2983 40.3575 20.3104 47.775 20.2461C55.2925 20.1818 61.3571 26.2691 61.3218 33.8519Z",
    fill: "#3C3675"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3373_50648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.9874,
    height: 52.9508,
    fill: "white",
    transform: "translate(20.25 20.2461)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.78b813677bf8fc7b3df6fddf1f79f885.svg";
export { ForwardRef as ReactComponent };